// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2pz9A","title":"FrontImage_title__2SGGy"};